import { createRequest } from '@savgroup-front-common/core/services/request';

export const GET_MODELS_BY_SEARCH_MODEL_QUERY = createRequest(
  'GET_MODELS_BY_SEARCH_MODEL_QUERY',
);

export const GET_MODEL_BY_ID = createRequest('CLAIMS/GET_MODEL_BY_ID');
export const LOAD_MODELS_INFO = createRequest('CLAIMS/LOAD_MODELS_INFO');
export const GET_MODEL_REPARABILITY = createRequest('GET_MODEL_REPARABILITY');
